const APP_CLIENT_VERSION = process.env.COMMIT_TAG || 'UNKNOWN';

export const commonConstants = {
    APP_CLIENT_VERSION,
};
